import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: 0,
    paddingLeft: theme.spacing(0.5),
  },
}));

export default function StatusCheckbox({
  value,
  currentValue,
  label,
  onChange,
}) {
  const classes = useStyles();

  return (
    <FormControlLabel
      label={label}
      className={classes.root}
      control={
        <Checkbox
          name="status"
          value={value}
          onChange={onChange}
          checked={value === currentValue}
          color="primary"
          size="small"
        />
      }
    />
  );
}

StatusCheckbox.propTypes = {
  value: PropTypes.string.isRequired,
  currentValue: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};
